<template>
  <div>
    <div class="all-slides" v-if="showAllSlides">
      <div class="back" v-on:click="hideAllSlides">
        Back to Slideshow
      </div>

      <div
        class="slide-container"
        v-for="(slide, index) in allSlides"
        v-bind:key="slide._id"
        v-bind:class="{selected: slideSelected(slide)}"
        v-on:click="selectSlide(slide, index)">
          <div class="slide-position">
            {{slidePosition(slide)}}
          </div>
          <div
            class="slide"
            v-bind:style="{ 'background-image': 'url(' + slide.preview_image + '), url(' + slide.image + '), url(https://powerslide-images.s3.amazonaws.com/placeholder.svg)' }" >
          </div>

          <div class="slide-title">
            {{slide.name}}
          </div>
      </div>

      <div class="button confirm-slides" v-on:click="confirmSlideSelection">
        Confirm Slide Selection
      </div>
    </div>

    <div class="slide-editor" v-if="!showAllSlides">
      <div class="back" v-on:click="goBack">
        Back to Dashboard
      </div>

      <div class="item-container">
        <label>Name</label>
        <input type="text" class="name-input" v-model="slideshow.name" v-on:blur="updateSlideshow(slideshow)" maxlength="22" placeholder="Slideshow Name">
      </div>

      <div class="item-container">
        <label>Slides</label>

        <div
          class="slide-container"
          v-for="slide in slideshow.slides"
          v-bind:key="slide._id">
            <div
              class="slide"
              v-bind:style="{ 'background-image': 'url(' + slide.preview_image + '), url(' + slide.image + '), url(https://powerslide-images.s3.amazonaws.com/placeholder.svg)' }" >
            </div>

            <div class="slide-title">
              {{slide.name}}
            </div>
        </div>

        <div class="new-slide" v-on:click="editSlides">
          <div class="new-slide-title">
            Add and Remove Slides
          </div>
        </div>
      </div>

      <button class="button" v-on:click="previewSlideshow">
        Preview Slideshow
      </button>

      <button class="button delete" v-on:click="toggleDeleteSlideshow" v-if="!deleteSlideshow">
        Delete Slideshow
      </button>

      <button class="button" v-on:click="cancelDeleteSlideshow" v-if="deleteSlideshow">
        Cancel
      </button>

      <button class="button delete" v-on:click="confirmDeleteSlideshow" v-if="deleteSlideshow">
        Confirm Delete
      </button>
    </div>
  </div>
</template>

<script>
import '../styles/base.css'
// import arrayMove from 'array-move'
import SwitchButton from './SwitchButton.vue'

export default {
  name: 'SlideshowEditor',
  data () {
    return {
      allSlides: [],
      deleteIndex: null,
      deleteSlideshow: false,
      newImage: '',
      newSlides: [],
      showAllSlides: false,
      slideshows: []
    }
  },

  components: {
    SwitchButton
  },

  methods: {
    cancelDeleteSlideshow: function () {
      this.deleteSlideshow = false
    },

    confirmDeleteSlide: function (index) {
      this.slideshow.slides.splice(index, 1)
      this.updateSlideshow(this.slideshow)
      this.deleteIndex = null
    },

    confirmDeleteSlideshow: function () {
      this.axios.delete('/api/slideshow/' + this.slideshow._id).then((response) => {
        this.$parent.setCurrentMessage('Slideshow deleted', false)
        this.$parent.setSelectedPane('slideshows')
      }).catch((error) => {
        this.$parent.setCurrentMessage(error, true)
      })
    },

    confirmSlideSelection: function () {
      if (this.slideshow.slides !== undefined) {
        this.slideshow.slides = JSON.parse(JSON.stringify(this.newSlides))
        this.updateSlideshow(this.slideshow)
      } else {
        this.slideshow.slides = JSON.parse(JSON.stringify(this.newSlides))
        this.createSlideshow(this.slideshow)
      }

      this.newSlides = []
      this.hideAllSlides()
    },

    createSlideshow: function () {
      this.slideshow.organization_id = PS.user.organization_id

      if (this.slideshow.name === undefined) {
        this.slideshow.name = 'Slideshow Name'
      }

      if (this.slideshow.controls === undefined) {
        this.slideshow.controls = false
      }

      if (this.slideshow.pagination === undefined) {
        this.slideshow.pagination = false
      }

      this.axios.post('/api/slideshow', this.slideshow).then((response) => {
        this.$gtag.event('slideshow-created', { method: 'Google' })
        this.$parent.setCurrentMessage('Slideshow created successfully', false)
      }).catch((error) => {
        this.$parent.setCurrentMessage(error, true)
        console.log('Error: ', error)
      })
    },

    editSlides: function () {
      this.axios.get('/api/slides/' + PS.user.organization_id).then((response) => {
        this.allSlides = response.data
        localStorage.setItem('slides', JSON.stringify(this.allSlides))

        this.allSlides.forEach(slide => {
          slide.selected = false
        })

        if (this.slideshow.slides !== undefined) {
          this.newSlides = JSON.parse(JSON.stringify(this.slideshow.slides))
        }
        this.showAllSlides = true
      }).catch((errors) => {
        localStorage.clear()
        this.$router.push('/login')
      })
    },

    getUserSlideshows: function () {
      this.axios.get('/api/slideshow/' + PS.user.organization_id).then((response) => {
        if (response.data !== undefined) {
          this.slideshows = response.data
        } else {
          this.slideshows = []
        }
      }).catch((errors) => {
        localStorage.clear()
        this.$router.push('/login')
      })
    },

    goBack: function () {
      this.$parent.setSelectedPane('slideshows')
    },

    hideAllSlides: function () {
      this.showAllSlides = false
    },

    removeSlide: function (slide) {
      for (var i = 0; i < this.newSlides.length; i++) {
        if (this.newSlides[i]._id === slide._id) {
          this.newSlides.splice(i, 1)
        }
      }
    },

    previewSlideshow: function () {
      this.$router.push({name: 'slider2', params: { slideshow: this.slideshow }})
    },

    slidePosition: function (slide) {
      let index = null

      for (var i = 0; i < this.newSlides.length; i++) {
        if (this.newSlides[i]._id === slide._id) {
          index = i + 1
        }
      }

      return index
    },

    selectSlide: function (slide, index) {
      if (this.slideSelected(slide)) {
        this.removeSlide(slide)
      } else {
        this.newSlides.push(slide)
      }
    },

    slideSelected: function (slide) {
      let found = false

      for (var i = 0; i < this.newSlides.length; i++) {
        if (this.newSlides[i]._id === slide._id) {
          found = true
        }
      }

      return found
    },

    toggleDeleteSlideshow: function () {
      this.deleteSlideshow = true
    },

    updateSlideshow: function (data) {
      let slideshow = JSON.parse(JSON.stringify(data))

      if (slideshow.name === '') {
        slideshow.name = 'Slideshow Name'
      }

      let idArray = []

      slideshow.slides.forEach(slide => {
        idArray.push(slide._id)
      })

      slideshow.slides = idArray

      this.axios.put('/api/slideshow/' + slideshow._id, slideshow).then((response) => {
        this.$gtag.event('slideshow-updated', { method: 'Google' })
        this.$parent.setCurrentMessage('Slideshow updated successfully', false)

        this.getUserSlideshows()
      }).catch((error) => {
        this.$parent.setCurrentMessage(error, true)
      })
    }
  },

  props: ['slideshow']
}
</script>

<style scoped>
  .button {
    display: block;
    font-size: 1.2em;
    margin-top: 1.5em;
    padding: 1em;
    width: 300px;
  }

  .caption-input {
    padding: .25em !important;
    width: 100% !important;
  }

  .confirm-slides {
    display: block;
  }

  .delete {
    background: var(--error);
  }

  .delete:hover {
    background: var(--error-hover) !important;
  }

  input[type=text], input[type=number] {
    border: 1px solid #ccc;
    display: block;
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    font-size: 1.2em;
    margin-top: 5px;
    outline: none;
    padding: 1em;
    width: 125px;
  }

  h2 {
    margin: 0;
  }

  .item-container {
    padding: 1em 0;
  }

  label {
    display: block;
    font-size: 1.5em;
  }

  .name-input {
    width: 245px !important;
  }

  .new-slide {
    border: 3px dashed var(--med-grey);
    border-radius: 6px;
    cursor: pointer;
    display: inline-block;
    height: 208px;
    justify-content: space-around;
    margin: 1em;
    position: relative;
    transition: all 0.25s ease-out;
    width: 288px;
  }

  .new-slide:hover {
    background: white;
    border: solid var(--secondary);
    transform: scale(1.1);
  }

  .new-slide-title {
    color: var(--med-grey);
    font-size: 1.5em;
    font-weight: 500;
    left: 50%;
    position: absolute;
    text-align: center;
    top: 50%;
    transform: translate(-50%, -50%);
  }

  select {
    -webkit-appearance: none;
    -moz-appearance: none;
    -ms-appearance: none;
    appearance: none;
    background: url('../assets/images/select-icon.svg') 93% / 10% no-repeat white;
    border: 1px solid #ccc;
    border-radius: 0;
    font-size: 1.2em;
    padding: .25em;
    width: 50%;
  }

  .selected {
    box-shadow: 0 0 3pt 2pt var(--secondary) !important;
  }

  .slide {
    background: rgb(48, 48, 48);
    background-repeat: no-repeat;
    background-size: cover;
    border: none;
    border-radius: 6px 6px 0px 0px;
    cursor: pointer;
    height: 162px;
    width: 288px;
  }

  .slide-container {
    background: white;
    box-shadow: 0 1px 9px 1px rgba(39,39,39,.2);
    border-radius: 6px;
    cursor: pointer;
    display: inline-block;
    justify-content: space-around;
    margin: 1em;
    transition: all 0.25s ease-out;
    vertical-align: top;
    width: 288px;
  }

  .slide-container:hover {
    transform: scale(1.1);
  }

  .slide-position {
    color: var(--sidebar-bg);
    font-size: 6em;
    font-weight: 900;
    left: 50%;
    position: absolute;
    text-align: center;
    top: 50%;
    transform: translate(-50%, -50%);
    z-index: 2;
    -webkit-text-stroke: 5px var(--secondary);
  }

  .slide-title {
    color: var(--dashboard-text);
    display: inline-block;
    padding: .75em;
    text-align: left;
  }
</style>
